import { getCurrentAccountId, getCurrentUserEmail } from '../../../utils/tokenUtils.ts';
import cn from 'classnames';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './userDropdown.module.scss';
import type { Account } from '../../../redux/types.ts';
import { PushPinSimpleIcon } from '@phosphor-icons/react/dist/csr/PushPinSimple';
import { UserCheckIcon } from '@phosphor-icons/react/dist/csr/UserCheck';
import { UserCirclePlusIcon } from '@phosphor-icons/react/dist/csr/UserCirclePlus';
import { UserSwitchIcon } from '@phosphor-icons/react/dist/csr/UserSwitch';

type AccountItemsProps = {
  backToUserMode: () => void;
  onRedirectToCreateAccount: () => void;
  onRedirectToSelectAccount: () => void;
  onChangeAccount: (account: Account) => void;
  pinnedAccounts: Account[];
};

const { userMenuDivider, userMenuItem, userMenuActive, iconPinnedAccount, iconAccount, iconUser } = styles;

const AccountItems: FC<AccountItemsProps> = ({
  backToUserMode,
  onRedirectToCreateAccount,
  onRedirectToSelectAccount,
  onChangeAccount,
  pinnedAccounts,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'userDropdown' });
  const { pathname } = window.location;

  return (
    <>
      <div className={userMenuItem} onClick={backToUserMode}>
        <UserCheckIcon size={24} className={iconUser} />
        {t('returnTo')} {getCurrentUserEmail() ?? t('user')}
      </div>
      <div className={userMenuDivider}></div>
      <div
        className={cn(userMenuItem, { [userMenuActive]: pathname === '/create-account' })}
        onClick={onRedirectToCreateAccount}
      >
        <UserCirclePlusIcon size={24} className={iconAccount} />
        {t('createAccount')}
      </div>
      <div
        className={cn(userMenuItem, { [userMenuActive]: pathname === '/select-account' })}
        onClick={onRedirectToSelectAccount}
      >
        <UserSwitchIcon size={24} className={iconAccount} />
        {t('changeAccount')}
      </div>
      {pinnedAccounts.map(account => (
        <div
          className={cn(userMenuItem, { [userMenuActive]: getCurrentAccountId() === account.accountId })}
          key={account.accountId}
          onClick={() => onChangeAccount(account)}
        >
          <PushPinSimpleIcon size={24} weight="fill" className={iconPinnedAccount} />
          {`${account.accountId} - ${account.name}`}
        </div>
      ))}
    </>
  );
};

export default AccountItems;
